module.exports = __webpack_public_path__ + "static/media/error.8358b3f2.png";